import { useState } from 'react'

function LinkList({
  links = [],
  onAdd,
  onDelete,
  editable = false,
  loading = false,
}) {
  const [newUrl, setNewUrl] = useState('')
  const [newTitle, setNewTitle] = useState('')
  const [showAddForm, setShowAddForm] = useState(false)

  const handleAdd = (e) => {
    e.preventDefault()
    if (!newUrl.trim()) return
    onAdd(newUrl.trim(), newTitle.trim() || null)
    setNewUrl('')
    setNewTitle('')
    setShowAddForm(false)
  }

  const getDomain = (url) => {
    try {
      const urlObj = new URL(url)
      return urlObj.hostname.replace('www.', '')
    } catch {
      return url
    }
  }

  const truncateUrl = (url, maxLength = 40) => {
    if (url.length <= maxLength) return url
    return url.slice(0, maxLength) + '...'
  }

  if (!editable && links.length === 0) {
    return null
  }

  return (
    <div className="link-list">
      {links.length > 0 && (
        <div className="link-header" style={{ marginBottom: '0.5rem' }}>
          <span className="text-sm text-muted">
            Links ({links.length})
          </span>
        </div>
      )}

      <div className="link-items" style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
        {links.map(link => (
          <div
            key={link.id}
            className="link-item"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              padding: '0.25rem 0',
            }}
          >
            <span style={{ fontSize: '0.875rem' }}>🔗</span>
            <a
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                flex: 1,
                fontSize: '0.875rem',
                color: 'var(--primary)',
                textDecoration: 'none',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
              title={link.url}
            >
              {link.title || getDomain(link.url)}
              {!link.title && (
                <span style={{ color: 'var(--gray-400)', marginLeft: '0.25rem' }}>
                  - {truncateUrl(link.url)}
                </span>
              )}
            </a>
            {editable && (
              <button
                type="button"
                onClick={() => onDelete(link.id)}
                className="btn btn-ghost btn-sm"
                style={{
                  padding: '0.125rem 0.25rem',
                  fontSize: '0.75rem',
                  color: 'var(--gray-400)',
                }}
                title="Remove link"
              >
                &times;
              </button>
            )}
          </div>
        ))}
      </div>

      {editable && !showAddForm && (
        <button
          type="button"
          onClick={() => setShowAddForm(true)}
          className="btn btn-ghost btn-sm"
          style={{ marginTop: '0.5rem', fontSize: '0.75rem' }}
        >
          + Add Link
        </button>
      )}

      {editable && showAddForm && (
        <form onSubmit={handleAdd} style={{ marginTop: '0.5rem' }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            <input
              type="url"
              value={newUrl}
              onChange={(e) => setNewUrl(e.target.value)}
              placeholder="https://..."
              className="form-input"
              style={{
                padding: '0.375rem 0.5rem',
                fontSize: '0.875rem',
              }}
              required
            />
            <input
              type="text"
              value={newTitle}
              onChange={(e) => setNewTitle(e.target.value)}
              placeholder="Link title (optional)"
              className="form-input"
              style={{
                padding: '0.375rem 0.5rem',
                fontSize: '0.875rem',
              }}
            />
            <div style={{ display: 'flex', gap: '0.5rem' }}>
              <button
                type="button"
                onClick={() => { setShowAddForm(false); setNewUrl(''); setNewTitle('') }}
                className="btn btn-ghost btn-sm"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="btn btn-secondary btn-sm"
                disabled={!newUrl.trim() || loading}
              >
                Add Link
              </button>
            </div>
          </div>
        </form>
      )}
    </div>
  )
}

export default LinkList
